import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { PAGE_BG, CARD_BG, BORDER, TEXT_MAIN, TEXT_MUTED, PRIMARY, PRIMARY_HOVER, CARD_RADIUS, FONT, FS_TITLE, FS_BODY, FS_LABEL } from './tokens';
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import LanguageSwitcher from '../Topbar/LanguageSwitcher';

export default function QuizWelcome({ companyName, logoUrl, welcomeHtml, showLanguage, onBegin, onLeave, t }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: PAGE_BG, fontFamily: FONT }}>
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: 900,
                        backgroundColor: CARD_BG,
                        borderRadius: CARD_RADIUS,
                        border: `1px solid ${BORDER}`,
                        p: { xs: 3, sm: 4 },
                    }}
                >
                    {showLanguage && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 2,
                                mb: 3,
                                pb: 2,
                                borderBottom: `1px solid ${BORDER}`,
                            }}
                        >
                            <Typography sx={{ fontWeight: 600, fontSize: FS_LABEL, color: TEXT_MUTED }}>
                                {t('select_language')}
                            </Typography>
                            <LanguageSwitcher />
                        </Box>
                    )}

                    {logoUrl && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                            <Box
                                component="img"
                                src={logoUrl}
                                alt={companyName}
                                sx={{ height: 52, width: 'auto', objectFit: 'contain' }}
                            />
                        </Box>
                    )}

                    <Typography
                        component="h1"
                        sx={{
                            fontWeight: 700,
                            fontSize: FS_TITLE,
                            color: TEXT_MAIN,
                            lineHeight: 1.25,
                            mb: 6,
                        }}
                    >
                        {t('welcome')}
                    </Typography>

                    {welcomeHtml && (
                        <Box
                            sx={{ fontSize: FS_BODY, color: TEXT_MUTED, lineHeight: 1.7, mb: 3, whiteSpace: 'pre-wrap' }}
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(welcomeHtml) }}
                        />
                    )}

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            onClick={onBegin}
                            sx={{
                                backgroundColor: PRIMARY,
                                px: 4,
                                py: 1.25,
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: FS_BODY,
                                textTransform: 'none',
                                '&:hover': { backgroundColor: PRIMARY_HOVER },
                            }}
                        >
                            {t('start_survey')}
                        </Button>
                        <Button
                            variant="text"
                            onClick={onLeave}
                            sx={{
                                color: TEXT_MUTED,
                                fontWeight: 500,
                                fontSize: FS_BODY,
                                textTransform: 'none',
                                '&:hover': { backgroundColor: 'transparent', color: TEXT_MAIN },
                            }}
                        >
                            {t('leave')}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
